import {useEffect, useRef, useState} from 'react';
import { InputNumber, Slider } from 'antd';
import {useViewerStore} from "../../../store/store";

type SliderInputProps = {
    settings: any,
    onChange: any,
    value: number,
    unit?: string,
    onChangeComplete?: (oldValue: number, newValue: number)=> void,
    sliderMarks?: any,
    hideInput?: boolean,
    disabled?: boolean,
    included?: boolean,
}

const SliderInput = (props: SliderInputProps) => {
    const {settings, onChange, value, unit, onChangeComplete, sliderMarks, hideInput, disabled, included} = props;

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const inputRef = useRef<HTMLInputElement>(null);
    const [inputValue, setInputValue] = useState(Number(value));
    const [oldValue, setOldValue] = useState(Number(value));

    const onChangeCompleteHandler = () => {
        if (inputValue === null || oldValue === inputValue) return

        onChangeComplete?.(inputValue, oldValue);
        setOldValue(inputValue);
        inputRef.current?.blur();
    };

    const inputChangeHandler = (newValue: number | null) => {
        if(newValue) setInputValue(newValue);
    };

    const inputOnChangeCompleteHandler = () => {
        if (inputValue < settings.min || inputValue > settings.max) {
            sceneViewer.viewerAlert({
                title: 'Value Error',
                message: `Cannot set value outside of range ${settings.min} - ${settings.max} ${unit ? ` ${unit}` : ''}`,
                messageType: 'error',
                show: true,
                isModal: false,
                isCloseAfterDisplay: true,
                autoCloseSeconds : 5000
            })
            setInputValue(value);
        } else {
            onChange(inputValue);
            onChangeCompleteHandler();
        }
    };

    useEffect(() => {
        setInputValue(value);
    }, [value]);

    return (
        <div className="slider-input-container">
            <div className="slider-input-range" style={hideInput ? { width: '100%' } : undefined}>
                <Slider
                    min={settings.min}
                    max={settings.max}
                    step={settings.step}
                    included={included}
                    onChange={onChange}
                    disabled = {disabled}
                    onChangeComplete={onChangeCompleteHandler}
                    tooltip={{
                        formatter: null,
                    }}
                    value={value}
                    marks={sliderMarks}
                    style={hideInput ? { marginBottom: '20px' } : undefined}
                />
            </div>
            {!hideInput && (
                <div className="slider-input-value">
                    <InputNumber
                        ref={inputRef}
                        step={settings.step}
                        value={inputValue}
                        onChange={inputChangeHandler}
                        onPressEnter={inputOnChangeCompleteHandler}
                        onBlur={inputOnChangeCompleteHandler}
                        onKeyDown={
                        (e) => {
                            if(e.key === 'Escape') {
                                setInputValue(value);
                                inputRef.current?.blur();
                            }
                        }
                        }
                    />
                </div>
            )}
        </div>
    );
};

export default SliderInput;